import { createSlice } from "@reduxjs/toolkit";

const authStates = createSlice({
    name: 'authStates',
    initialState: {
        loading: true, // for initial because token/cookiew checking will be placed on home route loading;
        isUserAuthenticated: false,
    },
    reducers: {
        updateAuthenticationState: (state, action) => {
            return { ...state, isUserAuthenticated: action.payload, isUserAuthenticated: action.payload, loading: false }
        },
        updateLoadingStates: (state, action) => {
            return { ...state, loading: action.payload }
        }
    },

});

export const { updateAuthenticationState, updateLoadingStates } = authStates.actions;
export default authStates.reducer;